// @mui
import { styled } from '@mui/material/styles';

// ----------------------------------------------------------------------

export const StyledList = styled('div')(() => ({
  paddingLeft: 20,
  paddingRight: 20,
  '& ul li': {
    display: 'list-item',
    padding: 0,
  },
  '& ul li::marker': {
    fontWeight: 'bold',
  },
  '& ul li h6': { fontFamily: 'Verdana', marginTop: 20 },
  '& ul li p': { fontFamily: 'Verdana' },
}));
